import React from "react";
import {
  FORGET_PASSWORD_URL,
  FORGET_PASSWORD_ENDUSER,
} from "../../constants/ApiPaths";
import {
  Button,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input,
} from "reactstrap";
import { USER_SIGNIN } from "../../constants/RoutePaths";
import { Link } from "react-router-dom";
import { authCustomerHeader } from "../../functions/CoreFunctions";
import { getAuthAgencyId } from "../common/CommonFunctions";

export default function CustomerUpdatePassword(props) {
  const {
    reloading,
    enqueueSnackbar,
    setReLoading,
    history,
    useFormik,
    Yup,
    API,
    CustomAlertMessage,
    CustomButtonLoader,
    email,
    setLoading,
  } = props;
  // intial values
  const agencyUrl = localStorage.getItem("CUSTOMER_URL");
  const initialValues = {
    email: email,
    otpValue: "",
    password: "",
    confirmPassword: "",
  };
  // validation schema
  const validationSchema = Yup.object().shape({
    otpValue: Yup.number().required("OTP is Required"),
    password: Yup.string()
      .min(6, "Minimum 6 charcters required")
      .required("Password is Required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is Required"),
  });

  //formik
  const { handleSubmit, handleChange, values, handleBlur, errors, touched } =
    useFormik({
      initialValues: initialValues,
      validationSchema,
      onSubmit: (values) => getUpdatePassword(values),
    });

  //for updating password
  const getUpdatePassword = async (values) => {
    const { email, otpValue, password } = values;
    setReLoading(true);
    const config = {
      method: "PUT",
      url: FORGET_PASSWORD_URL,
      // data: values,
      headers: authCustomerHeader(),
      data: {
        email: email,
        otpValue: otpValue,
        password: password,
        agencyUrl: agencyUrl,
        hyperlink: `${window.location.host}/customer/${agencyUrl}`,
      },
    };
    try {
      const response = await API(config);
      const { status, message } = response.data;
      if (status === "Success") {
        CustomAlertMessage(message, "success", enqueueSnackbar);
        history(`${USER_SIGNIN}/${agencyUrl}`);
      }
    } catch (error) {
      if (error.response) {
        console.error(error.response);
        const { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setReLoading(false);
    }
  };

  //for getting otp
  const getOTP = async (email) => {
    setLoading(true);
    const config = {
      method: "POST",
      url: FORGET_PASSWORD_ENDUSER,
      data: { email: email, agencyId: getAuthAgencyId() },
      headers: authCustomerHeader(),
    };
    try {
      const response = await API(config);
      const { status, message } = response.data;
      if (status === "Success") {
        CustomAlertMessage(message, "success", enqueueSnackbar);
      }
    } catch (error) {
      if (error.response) {
        const { data } = error.response;
        CustomAlertMessage(data.message, "error", enqueueSnackbar);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <h4>Update Your Account</h4>
      <p className="mb-4">{email && `We sent OTP successfully to ${email}`}</p>
      <Form form="true" onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="OTP">OTP</Label>
          <Input
            type="number"
            onBlur={handleBlur}
            name="otpValue"
            value={values.otpValue}
            invalid={touched.otpValue && errors.otpValue ? true : false}
            onChange={handleChange}
            id="OTP"
            placeholder="Enter OTP"
          />
          <FormFeedback>
            {touched.otpValue && errors.otpValue ? errors.otpValue : ""}
          </FormFeedback>
        </FormGroup>
        <FormGroup>
          <Label for="password">New Password</Label>
          <Input
            type="password"
            onBlur={handleBlur}
            name="password"
            value={values.password}
            invalid={touched.password && errors.password ? true : false}
            onChange={handleChange}
            id="password"
            placeholder="Enter Password"
          />
          <FormFeedback>
            {touched.password && errors.password ? errors.password : ""}
          </FormFeedback>
        </FormGroup>
        <FormGroup>
          <Label for="confirmPassword">Confirm Password</Label>
          <Input
            type="password"
            onBlur={handleBlur}
            name="confirmPassword"
            value={values.confirmPassword}
            invalid={
              touched.confirmPassword && errors.confirmPassword ? true : false
            }
            onChange={handleChange}
            id="OTP"
            placeholder="Confirm Password"
          />
          <FormFeedback>
            {touched.confirmPassword && errors.confirmPassword
              ? errors.confirmPassword
              : ""}
          </FormFeedback>
        </FormGroup>
        {/* Button */}
        <Button color="primary" type="submit" block>
          {reloading && <CustomButtonLoader />}
          Update
        </Button>
        <Link onClick={() => getOTP(email)}>Didn't get OTP?</Link>
      </Form>
    </div>
  );
}
